var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28918 4.12048H3.66268H14.6506",
    stroke: "#BF4B4B",
    strokeWidth: 1.37349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2771 4.12048V13.7349C13.2771 14.0992 13.1323 14.4486 12.8748 14.7061C12.6172 14.9637 12.2678 15.1084 11.9036 15.1084H5.03609C4.67182 15.1084 4.32246 14.9637 4.06488 14.7061C3.8073 14.4486 3.6626 14.0992 3.6626 13.7349V4.12048M5.72284 4.12048V2.74699C5.72284 2.38272 5.86755 2.03336 6.12513 1.77578C6.38271 1.5182 6.73206 1.3735 7.09633 1.3735H9.84332C10.2076 1.3735 10.5569 1.5182 10.8145 1.77578C11.0721 2.03336 11.2168 2.38272 11.2168 2.74699V4.12048",
    stroke: "#BF4B4B",
    strokeWidth: 1.37349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09644 7.55421V11.6747",
    stroke: "#BF4B4B",
    strokeWidth: 1.37349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84338 7.55421V11.6747",
    stroke: "#BF4B4B",
    strokeWidth: 1.37349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d7297cf75a3a6e40a12a8da99c90c447.svg";
export { ForwardRef as ReactComponent };